
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/about-us/join-us/submission-success",
      function () {
        return require("private-next-pages/us/about-us/join-us/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/about-us/join-us/submission-success"])
      });
    }
  